<template>

</template>

<script>
import {ProductMixin} from './ProductMixin';

export default {
    name: "SingleProduct",
    mixins: [ProductMixin],
    props: ['id', 'slug'],
    methods: {
        scripts() {
            $(window).scroll(() => {
                let navOffset = $("#single-product-nav-container").offset().top;
                if ($(window).scrollTop() > navOffset + 100) {
                    $("#single-product-nav-container .single-product__nav-wrapper").addClass('sticky');
                } else {
                    $("#single-product-nav-container .single-product__nav-wrapper").removeClass('sticky');
                }
            });
        }
    },
    mounted() {
        this.request(this.slug);
        this.scripts();
    }
}
</script>

<style scoped>

</style>
